export const GET_MENU_STATUS = "GET_MENU_STATUS";
export const SET_MENU_STATUS = "SET_MENU_STATUS";
